// extracted by mini-css-extract-plugin
export var alertIcon = "_qj-0";